import React, { createContext, useContext, useState } from "react";

const CardDeckContext = createContext<any>({});

export const useCardDeckContext = () => useContext(CardDeckContext);

export const CardDeckProvider = ({ children, ...cardProps }) => {
    const [selectedCard, setSelectedCard] = useState(null);
    return (
        <CardDeckContext.Provider value={{...cardProps, selectedCard, setSelectedCard}}>
            {children}
        </CardDeckContext.Provider>);
}
